<div class="whistle dt-transform-origin" [style.animation-delay]="animationDelay">
  @if (icon) {
    <mat-icon [color]="iconColor">{{ icon }}</mat-icon>
  }
  <span>{{ text }}</span>
</div>
